import { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion'; // Import ekledik
import Card from '../components/Card'; // Motion Card bileşenimizi kullanacağız
import papers from '../data/papers';

export default function Papers() {
  const [selectedCategory, setSelectedCategory] = useState('sci');
  const categories = [
    { key: 'sci', label: 'SCI Yayınlar' },
    { key: 'national', label: 'Ulusal Yayınlar' },
    { key: 'conferences', label: 'Bildiriler' }
  ];

  const getPapersByCategory = (category) => {
    switch(category) {
      case 'sci': return papers.sci;
      case 'national': return papers.national;
      case 'conferences': return papers.conferences;
      default: return [];
    }
  };

  const currentPapers = getPapersByCategory(selectedCategory);

  return (
    <div className="min-h-screen">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <motion.h1 
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          className="text-4xl font-serif font-bold text-navy mb-8"
        >
            Yayınlar
        </motion.h1>

        {/* Category Filter */}
        <div className="mb-8 flex flex-wrap gap-3">
          {categories.map((category) => (
            <motion.button
              key={category.key}
              whileTap={{ scale: 0.95 }}
              onClick={() => setSelectedCategory(category.key)}
              className={`px-4 py-2 rounded-lg transition-all duration-300 ${
                selectedCategory === category.key
                  ? 'bg-navy text-white shadow-md'
                  : 'bg-white text-navy border-2 border-navy-light hover:bg-navy-light hover:text-white'
              }`}
            >
              {category.label} ({getPapersByCategory(category.key).length})
            </motion.button>
          ))}
        </div>

        {/* Papers List with AnimatePresence */}
        <motion.div layout className="space-y-6">
          <AnimatePresence mode='wait'> 
            {currentPapers.map((paper, index) => (
              <motion.div
                key={paper.id || index} // Her kategori değişiminde animasyon tetiklenmesi için unique key önemli
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -10 }}
                transition={{ duration: 0.3 }}
              >
                <Card>
                  <h3 className="text-xl font-serif font-bold text-navy mb-2">
                    {paper.title}
                  </h3>
                  <p className="text-gray-700 mb-2">{paper.authors}</p>
                  
                  {/* ... İçerik lojiği aynı kalıyor ... */}
                  {selectedCategory === 'sci' && (
                    <>
                      <p className="text-gray-600 mb-1"><strong>Dergi:</strong> {paper.journal}</p>
                      <p className="text-gray-600 mb-1"><strong>Yıl:</strong> {paper.year} {paper.volume && `, Cilt: ${paper.volume}`} {paper.issue && `, Sayı: ${paper.issue}`} {paper.pages && `, Sayfa: ${paper.pages}`}</p>
                      {paper.doi && (<p className="text-gray-600 mb-2"><strong>DOI:</strong> <a href={`https://doi.org/${paper.doi}`} target="_blank" rel="noopener noreferrer" className="text-navy hover:underline">{paper.doi}</a></p>)}
                    </>
                  )}
                  {selectedCategory === 'national' && (
                     <>
                      <p className="text-gray-600 mb-1"><strong>Dergi:</strong> {paper.journal}</p>
                      <p className="text-gray-600 mb-1"><strong>Yıl:</strong> {paper.year} {paper.volume && `, Cilt: ${paper.volume}`} {paper.issue && `, Sayı: ${paper.issue}`} {paper.pages && `, Sayfa: ${paper.pages}`}</p>
                      {paper.doi && (<p className="text-gray-600 mb-2"><strong>DOI:</strong> <a href={`https://doi.org/${paper.doi}`} target="_blank" rel="noopener noreferrer" className="text-navy hover:underline">{paper.doi}</a></p>)}
                    </>
                  )}
                  {selectedCategory === 'conferences' && (
                     <>
                      <p className="text-gray-600 mb-1"><strong>Konferans:</strong> {paper.conference}</p>
                      <p className="text-gray-600 mb-1"><strong>Yıl:</strong> {paper.year} {paper.month && `, ${paper.month}`}</p>
                      {paper.location && (<p className="text-gray-600 mb-1"><strong>Yer:</strong> {paper.location}</p>)}
                      {paper.pages && (<p className="text-gray-600 mb-1"><strong>Sayfa:</strong> {paper.pages}</p>)}
                      {paper.doi && (<p className="text-gray-600 mb-2"><strong>DOI:</strong> {paper.doi}</p>)}
                    </>
                  )}
                  
                  {paper.url && (
                    <motion.a
                      whileHover={{ x: 5 }}
                      href={paper.url}
                      className="inline-flex items-center gap-2 text-navy hover:underline font-medium mt-2"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Detaylar
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
                      </svg>
                    </motion.a>
                  )}
                </Card>
              </motion.div>
            ))}
          </AnimatePresence>
        </motion.div>
      </div>
    </div>
  );
}